export default "__VITE_ASSET__D$xwDY3m__"